import Debounce from '../../../../../../../ndsbase/Resources/Public/Assets/Js/Components/Debounce/debounce.js';

const menuSelector = '.js-menu';
const menuToggleLevelSelector = '.js-menu-toggle-level';
const menuToggleLevel1Selector = '.js-menu-toggle-level-1';
const menuLevelSelector = '.js-menu-level';

// breakpoint must match CSS breakpoint
const menuBreakpointMediaQuery = '(min-width: 768px)';

function initMenu() {
  const menuToggleLevelElems = document.querySelectorAll(menuToggleLevelSelector);

  updateMenuForViewportSize();

  window.addEventListener('resize', Debounce.debounce(() => {
    updateMenuForViewportSize();
  }, 500));

  menuToggleLevelElems.forEach(toggleLevelElem => {
    toggleLevelElem.addEventListener('click', event => {
      event.preventDefault();
      toggleLevel(toggleLevelElem);
    });
  });
}

const toggleLevel = function(toggleLevelElem) {
  toggleLevelElem.classList.toggle('is-active');
  const titleText = (toggleLevelElem.classList.contains('is-active')) ? toggleLevelElem.dataset.labelClose : toggleLevelElem.dataset.labelOpen;
  toggleLevelElem.setAttribute('title', titleText);
  const childLevelElem = toggleLevelElem.parentNode.querySelector(menuLevelSelector);
  childLevelElem.classList.toggle('is-active');
};

const openLevel = function(toggleLevelElem) {
  toggleLevelElem.classList.add('is-active');
  const childLevelElem = toggleLevelElem.parentNode.querySelector(menuLevelSelector);
  childLevelElem.classList.add('is-active');
};

const updateMenuForViewportSize = function() {
  const isTabletAndUp = window.matchMedia(menuBreakpointMediaQuery);
  if (isTabletAndUp.matches) {
    const menuToggleLevel1Elems = document.querySelectorAll(menuToggleLevel1Selector);
    menuToggleLevel1Elems.forEach(toggleLevelElem => {
      openLevel(toggleLevelElem);
    });
  }
};

if(document.querySelector(menuSelector) !== null) {
  initMenu();
}
